import { articleProps } from '@utils/initial'
import { Request } from '@group-devs/yfp7-global-modules'
import { stripTags, isDomain } from '@group-devs/yfp7-global-modules/utils/general'
import Error from '../404'
import { saveAs } from 'file-saver';
import axios from 'axios';
import Cookie from 'js-cookie'
import { useEffect, useState, useRef, useMemo } from 'react'
import Head from 'next/head'
import Link from 'next/link'
import { Container, Row, Col, Image, DropdownButton, Dropdown, Button } from 'react-bootstrap'
import { FaDownload, FaStar, FaShareAlt, FaLink } from 'react-icons/fa'
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton,
    FacebookIcon, TwitterIcon, LinkedinIcon,EmailIcon } from 'react-share'
import ReactPlayer from 'react-player/lazy'
// import { ModalVIP, WellnessLayout, Content } from '@components/Block'
import { WellnessLayout, Content } from '@components/Block'
import ModalReadMore from '@components/article/ModalReadMore';
import { StripContactMe, MoreRelatedContent, YourGuide, RelatedContent } from '@group-devs/yfp7-global-modules/components/Block'
// import { StripContactMe, MoreRelatedContent, YourGuide, RelatedContent } from '../../backup/components/Block'
import params from '@data/params'
import sectionData from '@data/sections'
import { useRouter } from 'next/router';

const request = new Request(process.env.apiDomain)

export async function getServerSideProps({req, res, query}) {
    return {
        props: await articleProps(req, res, query)
    }
}

function Pages(props) {
    if (typeof props.err !== "undefined")
        return <Error statusCode={props.err.code} />
    
    const router = useRouter()
    const { source } = router.query;

    const backofficeDomain = process.env.backofficeDomain;
    const [copied, setCopied] = useState(false);

    const site = props.site
    let auth = props.auth
    const article = props.article
    const data = article.data ? JSON.parse(article.data) : {}
    const url =  "/a/" + article.slug
    const domain = isDomain(site.url) ? 'www.'+site.url : site.url;
    const shareUrl = "https://" + domain + url+'?source=share'
    const image = article.featureImg ? article.featureImg : null
    const section = sectionData.filter((e) => e.id == article.type)
    const [duration, setDuration] = useState(0)
    const [videoDuration, setVideoDuration] = useState(0)

    const [totalSeconds, setTotalSeconds] = useState(0)
    const [progress, setProgress] = useState(false)
    const [videoPlayed, setVideoPlayed] = useState(0)

    const { data: profile  } = request.account.swrAccountProfile(site.accountId)
    const { data: social } = request.account.swrSocialMedia(site.accountId, profile ? profile.user.id : profile)
    const user_id = profile ? parseInt(profile.user.id) : '';

    const [showVIPModal, setShowVIPModal] = useState(false)
    const closeVIPModal = () => router.push("/")
    const openVIPModal = () => setShowVIPModal(true)

    const userId = props.auth.site_owner ? props.auth.userId : null
    const contact_id = props.auth.contactId ? props.auth.contactId : null;
    const content_id = parseInt(article.id)

    const {data: details} = request.content.swrContentDetails(parseInt(article.id), {user_id: userId, contact_id: contact_id})

    // Check if user is a Shaklee distributor
    const isShakleeDistributor = useMemo(() => {
        console.log('=== Checking Shaklee Distributor Status ===');
        
        // MUST be authenticated AND be a Shaklee distributor to show content
        if (!props.auth?.isAuthenticated) {
            console.log('❌ User not authenticated');
            return false;
        }
        
        console.log('✅ User is authenticated, checking distributor type...');
        
        // Method 1: Check in profile data
        if (profile?.distributor_type === 'shaklee') {
            console.log('✅ SHAKLEE DETECTED via profile.distributor_type:', profile.distributor_type);
            return true;
        }
        console.log('❌ profile.distributor_type:', profile?.distributor_type);
        
        // Method 2: Check in auth data
        if (props.auth?.distributor_type === 'shaklee') {
            console.log('✅ SHAKLEE DETECTED via auth.distributor_type:', props.auth.distributor_type);
            return true;
        }
        console.log('❌ auth.distributor_type:', props.auth?.distributor_type);
        
        // Method 3: Check in site configuration
        if (site?.company_type === 'shaklee' || site?.distributor_type === 'shaklee') {
            console.log('✅ SHAKLEE DETECTED via site config:', { 
                company_type: site?.company_type, 
                distributor_type: site?.distributor_type 
            });
            return true;
        }
        console.log('❌ site config:', { 
            company_type: site?.company_type, 
            distributor_type: site?.distributor_type 
        });
        
        // Method 4: Check in user data or other properties
        if (profile?.user?.company === 'shaklee' || profile?.user?.distributor === 'shaklee') {
            console.log('✅ SHAKLEE DETECTED via user data:', { 
                company: profile?.user?.company, 
                distributor: profile?.user?.distributor 
            });
            return true;
        }
        console.log('❌ user data:', { 
            company: profile?.user?.company, 
            distributor: profile?.user?.distributor 
        });
        
        // Method 5: Check if site URL or domain contains 'shaklee'
        if (site?.url?.toLowerCase().includes('shaklee') || domain?.toLowerCase().includes('shaklee')) {
            console.log('✅ SHAKLEE DETECTED via URL/domain:', { 
                site_url: site?.url, 
                domain: domain 
            });
            return true;
        }
        console.log('❌ URL/domain check:', { 
            site_url: site?.url, 
            domain: domain 
        });
        
        // If none of the above conditions are met, hide the content
        console.log('❌ NO SHAKLEE DETECTION - hiding content');
        console.log('=== End Shaklee Check ===');
        return false;
    }, [profile, props.auth, site, domain]);

    // Fetch data for search functionality
    const accountId = site.accountId;
    const { data: recentArticles } = request.content.swrArticles({ section: "wellness-center", except_types: [13], sort:"DATE_DESC", limit:50, user_id: userId, contact_id: contact_id })
    const { data: replaysArticles } = request.content.swrArticles({ section: "wellness-center", type:11, sort:"DATE_DESC", limit:20, user_id: userId, contact_id: contact_id })
    const { data: videosArticles } = request.content.swrArticles({ section: "wellness-center", type:2, sort:"DATE_DESC", limit:20, user_id: userId, contact_id: contact_id })

    // Create lightweight search index using useMemo for performance
    const searchableItems = useMemo(() => {
      // Combine all article arrays
      const allArticles = [
        ...(recentArticles || []),
        ...(replaysArticles || []),
        ...(videosArticles || [])
      ];
      
      const uniqueArticlesMap = new Map();
      
      // Create lightweight objects with only needed properties
      allArticles.forEach(article => {
        if (!uniqueArticlesMap.has(article.id)) {
            uniqueArticlesMap.set(article.id, {
                id: article.id,
                slug: article.slug,
                title: article.title
            });
        }
      });
    
      // Convert map values to array
      return Array.from(uniqueArticlesMap.values());
    }, [recentArticles, replaysArticles, videosArticles]);

    const player = useRef();
    const reactPlayer = player;
    const currentPlayer = reactPlayer && reactPlayer.current !== undefined ? reactPlayer.current : '';

    async function handleFilePoint() {

        if(props.auth.site_user){
            
            // Insert article point
            if(article.type == 4){

                await request.tracker.setArticlePoint(content_id, contact_id, params.points[article.type]);  
                
                console.log('insert file download points');
            }

        }

        await request.content.saveContentDetails(content_id, {user_id: userId, contact_id: contact_id, is_downloaded: 1});
    }

    const download = async function (url, name)
    {
        handleFilePoint();
        try 
        {
            const response = await axios.get(url, {
              responseType: 'blob', // Important to set responseType to 'blob'
            });
            
            saveAs(response.data, name);
        } catch (error) {
        console.error('Error downloading the file', error);
        }
        // saveAs(url, name)
    }

    async function handleVideoPointStatus(time, percentage) {
        
        const videoPercentage = percentage.toString();
        const videoTime = time.toString();

        if(props.auth.site_user){
            
            // Insert video point
            if(article.type == 2 || article.type == 11){

                await request.tracker.updateVideoPointStatus(content_id, contact_id);
                console.log('update video status');

            }

        }

        await request.content.saveContentDetails(content_id, {user_id: userId, contact_id: contact_id, is_watched: 1, played:  videoTime, percentage: videoPercentage});
                
    }

    async function handleVideoPoint(time, points, percentage) {
        
        const time_watched = time.toString();
        const videoPercentage = percentage.toString();

        if(props.auth.site_user && points > 0){
            
            // Insert video point
            if(article.type == 2 || article.type == 11){
                await request.tracker.setVideoPoint(content_id, contact_id, points, time_watched);
            }

        }
        else if(percentage > 0)
        {
            await request.content.saveContentDetails(content_id, {user_id: userId, contact_id: contact_id, is_watched: 1, played: time_watched, percentage: videoPercentage});
        }
    }


    const onReady = function (){
        return currentPlayer && videoPlayed > 0 ? currentPlayer.seekTo(videoPlayed) : ''
    }

    const onProgress = function (progressData) {

       
        if(progressData.playedSeconds > 0){
            const time = progressData.playedSeconds;
            const roundedTime = Math.round(progressData.playedSeconds);

            // FIXED: Always update progress in real-time for immediate UI display (both logged and non-logged users)
            setProgress(format(time));

            const progress = (Math.round(progressData.playedSeconds) / Math.round(videoDuration)) * 100;
            const percentage  = Math.round(progress);

            let points = 0

            if(roundedTime >= 60 && roundedTime <= 600 ){//1-10mins
                points = 1;
            }else if(roundedTime >= 660 && roundedTime <= 1200){//11-20mins
                points = 2;
            }else if(roundedTime >= 1260 && roundedTime <= 1800){//12-30mins
                points = 3;
            }else if(roundedTime >= 1860 && roundedTime <= 2400){//31-40mins
                points = 4;
            }
            else if(roundedTime >= 2460 && roundedTime <= 3000){//41-50mins
                points = 5;
            }
            else if(roundedTime >= 3060 && roundedTime <= 3600){//51-60mins
                points = 6;
            }
            else if(roundedTime >= 3660 && roundedTime <= 4200){//61-70mins
                points = 7;
            }
            else if(roundedTime >= 4260 && roundedTime <= 4800){//71-80mins
                points = 8;
            }
            else if(roundedTime >= 4860 && roundedTime <= 5400){//81-90mins
                points = 9;
            }
            else if(roundedTime >= 5460 && roundedTime <= 6000){//91-100mins
                points = 10;
            }
            else if(roundedTime >= 6060 && roundedTime <= 6600){//101-110mins
                points = 11;
            }
            else if(roundedTime >= 6660 && roundedTime <= 7200){//111-120mins
                points = 12;
            }
            else if(roundedTime >= 7260 && roundedTime <= 7800){//121-130mins
                points = 13;
            }

            handleVideoPoint(time, points, percentage);

        }
        
    }

    const onDuration = function (seconds) {
        setDuration(format(seconds))
        setVideoDuration(seconds)
    }

    const onEnded = function () {

        let videoPercentage = 0;
        let videoTime = 0;

        if (reactPlayer && reactPlayer.current !== undefined) {
            const current = reactPlayer.current

            const CurrentTime = Math.round(current.getCurrentTime())
            const Duration = Math.round(current.getDuration())
            const videoProgress = (CurrentTime / Duration) * 100;
            
            videoTime = current.getCurrentTime();
            videoPercentage =  Math.round(videoProgress);

        }
    
        handleVideoPointStatus(videoTime,videoPercentage);

        console.log('video ended');
    }



    async function handlePoint(event) {
        event.preventDefault()
        
        if(article.type == 1 || article.type == 12){

            if(props.auth.site_user){
                
                // Insert article and recipe points
                await request.tracker.setArticlePoint(content_id, contact_id, params.points[article.type]); 
                console.log('insert article points');
                
            }

            await request.content.saveContentDetails(content_id, {user_id: userId, contact_id: contact_id, is_read: 1});

        }
    }

    // FIXED: Format function with proper time rollover handling
    const format = function (seconds) {
        setTotalSeconds(seconds);

        // Round to nearest second first to avoid floating point issues
        const totalSeconds = Math.round(seconds);
        
        // Calculate hours, minutes, and seconds with proper rollover
        let h = Math.floor(totalSeconds / 3600);
        let m = Math.floor((totalSeconds % 3600) / 60);
        let s = totalSeconds % 60;
        
        // Handle edge case where seconds might be 60 due to rounding
        if (s >= 60) {
            s = 0;
            m += 1;
        }
        if (m >= 60) {
            m = 0;
            h += 1;
        }
        
        const formattedSeconds = String(s).padStart(2, '0'); // Ensures 2-digit format (00, 01, 02, etc.)

        if (h > 0) {
            // If hours exist, show hours and minutes
            return `${h} hr${h > 1 ? 's' : ''} & ${m} min${m !== 1 ? 's' : ''}`;
        } else if (m > 0) {
            // If minutes exist, show minutes and seconds
            return `${m} min${m > 1 ? 's' : ''} & ${formattedSeconds} sec${s !== 1 ? 's' : ''}`;
        } else {
            // Only seconds
            return `${formattedSeconds} sec${s !== 1 ? 's' : ''}`;
        }
    };
    
    useEffect(() => {
        let count = 1;
        window.addEventListener("scroll", (event) => {
            
            if (window.scrollY > 2000) {

                const counter = count++;

                if(counter === 1 ){

                    //read article
                    handlePoint(event);
                }
               
            }
        });
    }, []);


    useEffect(() => {
        if (typeof FB !== 'undefined')
            FB.XFBML.parse()
    }, [social])

    useEffect(() => {
        if (!props.auth.isAuthenticated)
            openVIPModal()
    }, [])

    // FIXED: Updated useEffect to allow real-time progress updates for non-logged users
    useEffect(() => {
        if (!props.auth.site_user) {
            // For non-logged users, start from 0 but allow real-time updates through onProgress
            setVideoPlayed(0);
            // Don't set progress to "0 sec" here - let onProgress handle it
        } else {
            const misc = details ? JSON.parse(details.misc_data) : '';
            const watched = misc ? misc.played : 0;
            setProgress(format(watched));
            setVideoPlayed(watched);
        }
    }, [details, props.auth.site_user]);
    
    useEffect(() => {
        if(source == "email" || source == "share" ){

            Cookie.set('show_article', 1, {
                expires: 365, // in days
                path: '/',
                sameSite: 'Lax',
                secure: false
            });

            Cookie.set('slug', article.slug, {
                expires: 365, // in days
                path: '/',
                sameSite: 'Lax',
                secure: false
            });

           window.location.href = url;
        }
    }, [source])

    // Add console logging for authentication and distributor status
    useEffect(() => {
        if (!props.auth?.isAuthenticated) {
            console.log('User not authenticated - Shaklee content hidden');
        } else if (props.auth?.isAuthenticated && profile) {
            if (isShakleeDistributor) {
                console.log('Shaklee distributor detected - showing nutrition plan section');
            } else {
                console.log('Non-Shaklee distributor detected - hiding nutrition plan section:', {
                    userId: profile?.user?.id,
                    distributorType: profile?.distributor_type || 'unknown',
                    company: profile?.user?.company || 'unknown',
                    siteInfo: {
                        accountId: site?.accountId,
                        companyType: site?.company_type || 'unknown',
                        url: site?.url || 'unknown'
                    },
                    authInfo: {
                        distributorType: props.auth?.distributor_type || 'unknown',
                        siteOwner: props.auth?.site_owner,
                        isAuthenticated: props.auth?.isAuthenticated
                    },
                    profileData: profile // Log full profile to see available properties
                });
            }
        } else if (props.auth?.isAuthenticated && !profile) {
            console.log('User authenticated but profile not loaded yet - Shaklee content hidden');
        }
    }, [profile, isShakleeDistributor, site, props.auth]);

    const copyToClipboard = () => {

        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            
            // Use the modern Clipboard API if available
            navigator.clipboard.writeText(shareUrl)
            .then(() => {
              setCopied(true);
              setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
            })
            .catch(err => {
              console.error('Failed to copy: ', err);
            });

        } else {

            // Fallback method using a temporary textarea
            const textArea = document.createElement("textarea");
            textArea.value = shareUrl;
            document.body.appendChild(textArea);
            textArea.select();

            try {

                document.execCommand('copy');
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds

            } catch (err) {
                console.error('Failed to copy using fallback method: ', err);
            }

            document.body.removeChild(textArea);
        }
    };

    return (
        <WellnessLayout global={props} article={article} searchItems={searchableItems}>
            <Container className="pt-5 my-5 wellnessCenter">
                <h1 className="h4 contentTitle lh-1-5">{ article.title }</h1>
                { article.tagline ? <p className="tagline">{article.tagline}</p> : null }
                <Row className="mt-5">
                    <Col md={8}>
                        <div className="d-flex h7 catLinks">
                            { 
                                article.type == 12 ? <p>Category: <Link href={ "/recipes/" + article.category.slug }><a><span className="text-blue">{ article.category.name }</span></a></Link></p>
                                : article.type == 4 ? <p>Category: <Link href={ "/file-cabinet/" + article.category.slug }><a><span className="text-blue">{ article.category.name }</span></a></Link></p>
                                : <p>Category: <Link href={ "/category/" + article.category.slug }><a><span className="text-blue">{ article.category.name }</span></a></Link></p>
                            }
                            {
                                section.length ? <p className="ml-4">Section: <Link href={"/" + section[0].route}><a><span className="text-blue">{article.typeLabel}</span></a></Link></p>
                                : <p className="ml-4">Section: <span className="text-blue">{article.typeLabel}</span></p>
                            }
                            <p className="ml-auto mr-lg-5"><FaStar className="text-warning"/> Value: <span className="text-blue">{params.points[article.type]} pts.</span></p>
                            <div className="dp-share">
                                {/*<DropdownButton alignRight size="sm" title={<>Share <FaShareAlt className="ml-1"/></>} id="dropdown-share">
                                    <FacebookShareButton  url={shareUrl} quote={article.title} className="mx-1"> <FacebookIcon  size={"1.5rem"} round/> </FacebookShareButton>
                                    <TwitterShareButton url={shareUrl} quote={article.title} hashtags={['wellness']} className="mx-1"> <TwitterIcon  size={"1.5rem"} round/> </TwitterShareButton>
                                    <LinkedinShareButton url={shareUrl} source={shareUrl} title={article.title} summary={ article.theExcerpt } className="mx-1"> <LinkedinIcon  size={"1.5rem"} round/> </LinkedinShareButton>
                                    <EmailShareButton url={shareUrl} quote={article.title} subject={article.title} className="mx-1"> <EmailIcon  size={"1.5rem"} round/> </EmailShareButton>
                                </DropdownButton>*/}
                                <DropdownButton alignRight size="sm" title={<>Share <FaShareAlt className="ml-1"/></>} id="dropdown-share">
                                    <Dropdown.ItemText>
                                        <p className="text-center mt-2">{shareUrl}</p>
                                        <p><Button variant="outline-secondary" onClick={copyToClipboard} size="sm">{copied ? 'Link Copied!' : 'Copy Link'}</Button> <Button variant="outline-secondary" size="sm" href={'https://www.facebook.com/sharer/sharer.php?u='+shareUrl} target="_blank">Share in Facebook</Button></p>
                                    </Dropdown.ItemText>
                                </DropdownButton>
                            </div>
                        </div>
                        { (article.type == 11 || article.type == 2) && data.media ? 
                            <ReactPlayer className="w-100" controls url={data.media}
                                ref={player}
                                onDuration={onDuration}
                                onProgress={onProgress}
                                progressInterval={1000}
                                onEnded={onEnded}
                                onReady={onReady}
                            /> 
                            : 
                            null
                        }
                        { article.type == 4 && data.media ? 
                            <>
                                <a onClick={() => data.urlPath ? download(backofficeDomain+data.urlPath+"?user_id="+user_id+"&download=true", data.saveAs ? data.saveAs : data.media ) : download(data.mediaUrl, data.saveAs ? data.saveAs : data.media )} className="mr-3 text-dark"><FaDownload/> Download</a> 
                                <Link href={data.urlPath ? backofficeDomain+data.urlPath+"?user_id="+user_id : "/file-cabinet/viewer/" + article.slug}><a className="text-dark" target="_blank"><FaLink/> View</a></Link>
                            </>
                        : null }
                        <div className="py-3 bodyContent">
                            { (article.type == 11 || article.type == 2) && data.media ?
                            <div className="mb-4">
                                <div className="d-flex justify-content-between mb-1">
                                    <p>
                                        { data.date ?  <><span><strong className="mr-2">Date recorded:</strong>{data.date}</span><br/></> : null}
                                        { duration ? <span><strong className="mr-2">Duration:</strong> {duration}</span> : null }
                                    </p>
                                    {/* FIXED: Show progress for all users, not just when progress !== "00 secs" */}
                                    {progress ? <p><strong className="mr-2">Watched:</strong>{progress}</p> : ''}
                                </div>
                            </div>
                            : null }

                            <Content props={props} />

                            {
                            /*
                            <div className="read-more-box-parent">
                                <div className="read-more-box-child">
                                    <Button className="btn-read-more py-2 border-0 rounded-0 m-auto d-block" variant="success" onClick={() => setModalReadMoreShow(true)} style={{cursor:"pointer"}}>Read More</Button>
                                </div>
                            </div>
                            */
                            }

                        </div>
                        <StripContactMe site={props.site} auth={props.auth} profile={profile} isShakleeDistributor={isShakleeDistributor} />
                        <MoreRelatedContent center="wellness-center" category={article.category} type={article.type} except={article.id} />
                    </Col>
                    <Col md={3}>
                        <YourGuide site={props} />
                        <RelatedContent center="wellness-center" category={article.category} type={article.type} except={article.id} />
                        <div className="relatecontent mt-4">
                        { social && social.facebook_fanpage ?
                            <div className="fb-page" 
                                data-href={"https://www.facebook.com/" + social.facebook_fanpage }
                                data-width="450"
                                data-height="152"
                                data-hide-cover="false"
                                data-show-facepile="false" 
                            >
                            </div>
                        : null }
                        </div>
                    </Col>
                </Row>
            </Container>
            {/* <ModalVIP article={article} show={showVIPModal} onHide={closeVIPModal} /> */}
            <style jsx global>{`
                .dashboardtopnav{
                    background-color: #43a649!important;
                    padding-top:0;
                    padding-bottom:0;
                }
                .relatecontent__title:after{
                    content: "";
                    width: 5rem;
                    height: .2rem;
                    background-color: #43a649;
                    display: block;
                }
                .badge-primary{
                    background-color: #dc3545;
                }
                .categoriesdropdown .dropdown-menu,
                .sectiondropdown .dropdown-menu{
                    -webkit-box-shadow: 0px 3px 5px -4px rgba(0,0,0,0.75);
                    -moz-box-shadow: 0px 3px 5px -4px rgba(0,0,0,0.75);
                    box-shadow: 0px 3px 5px -4px rgba(0,0,0,0.75);
                }
                .tagline{
                    font-size: 1.8rem;
                    font-weight: 700;
                }
                #dropdown-share{
                    background-color:transparent!important;
                    color: #000!important;
                    border: none!important;
                }
                .dp-share .dropdown-menu{
                    text-align: center;
                }
                .nutrition-plan-section{
                    background-color: #f8f9fa;
                    border: 1px solid #dee2e6;
                }
            
                @media(min-width:992px){
                    .contentTitle{
                        width:75%;
                        font-size: 2.5rem;
                        font-weight: 700;
                    }
                }
                @media(max-width:991px){
                    .catLinks,  #dropdown-share{
                        font-size: .7rem;
                    }
                    #dropdown-share{
                        margin-top: -3px;
                    }
                    
                }
            `}</style>
        </WellnessLayout>
    )
}

export default Pages